import { render, staticRenderFns } from "./EditorTest.vue?vue&type=template&id=7d48b924&"
import script from "./EditorTest.vue?vue&type=script&lang=ts&"
export * from "./EditorTest.vue?vue&type=script&lang=ts&"
import style0 from "./EditorTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports